import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function ProductIntro() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-gradient-to-b from-white to-orange-50 py-16 md:py-20" data-id="element-145">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-147">
          <h2 className="font-fredoka text-4xl sm:text-5xl md:text-6xl font-bold text-orange-600 mb-6" data-id="element-148">
            Presentamos: Aprendo Jugando · Learning Through Play
          </h2>

          <p className="text-xl sm:text-2xl font-nunito font-semibold text-gray-800 leading-relaxed" data-id="element-149">
            El libro de actividades imprimibles bilingüe que convierte el tiempo
            sin pantallas en el momento favorito de tu hijo.
          </p>
        </motion.div>
      </div>
    </section>;
}